import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { HeaderComponent } from './layout/header/header.component';  

// Routing
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { EventsService } from './shared/services/events/events.service';
// Components
import { HeaderModule, FooterModule } from './layouts';
import { ArtistDetailsModalComponent } from './layouts/artist-details-modal/artist-details-modal.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@NgModule({ 
  declarations: [
    AppComponent,
    ArtistDetailsModalComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule, 
    AppRoutingModule,
    HeaderModule,
    FooterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LazyLoadImageModule
  ],
  providers: [EventsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
